import { 
  Button, 
  Dialog, 
  DialogActions, 
  DialogTitle, 
  DialogContent, 
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useIsMobile } from "../../hooks/state-checkers/use-is-mobile";

export const ConfirmationDialog = ({
  isOpen,
  toggle,
  action,
  title,
  content,
  disableButton,
  hideOkButton,
}) => {
  const isMobile = useIsMobile();
  const muiTheme = useTheme();

  return (
    <Dialog
      maxWidth="xs"
      fullScreen={isMobile}
      aria-labelledby="confirmation-dialog-title"
      open={isOpen}
      onClose={toggle}
      fullWidth={true}
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, md: 1.5 },
          boxShadow: { xs: 'none', md: '0 24px 38px 3px rgba(0,0,0,0.14), 0 9px 46px 8px rgba(0,0,0,0.12), 0 11px 15px -7px rgba(0,0,0,0.2)' },
        },
      }}
    >
      <DialogTitle
        id="confirmation-dialog-title"
        sx={{
          textAlign: 'center',
          pb: 1,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: 'text.primary',
            fontWeight: 600,
            fontSize: '21px',
            lineHeight: 1.4,
          }}
        >
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          textAlign: 'center',
          px: 3,
          py: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: 'text.primary',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: 1.6,
          }}
        >
          {content}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          px: 3,
          py: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={toggle}
          autoFocus
          sx={{
            minWidth: 100,
            borderRadius: 1.5,
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            py: 1,
          }}
        >
          <FormattedMessage id="general.cancel" />
        </Button>
        {!hideOkButton && (
          <Button
            variant="contained"
            onClick={action}
            disabled={disableButton}
            sx={{
              minWidth: 100,
              borderRadius: 1.5,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1,
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            <FormattedMessage id="general.ok" />
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

